
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5af7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5af7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lA1wN", function(module, exports) {

$parcel$export(module.exports, "initHeaderActiveNav", function () { return $fb5e25347d6b7784$export$9a4306cb330df17c; });
$parcel$export(module.exports, "initHeaderCTA", function () { return $fb5e25347d6b7784$export$439db37d80004144; });
// assets/js/layout/header.js
function $fb5e25347d6b7784$export$9a4306cb330df17c() {
    const page = document.body.dataset.page;
    if (!page) return;
    document.querySelectorAll('.top-bar__nav-pill a, .top-bar__nav-panel a').forEach((link)=>{
        if (link.dataset.nav === page) link.classList.add('is-active');
    });
}
function $fb5e25347d6b7784$export$439db37d80004144() {
    const cta = document.querySelector('[data-header-cta]');
    if (!cta) return;
    const page = document.body.dataset.page;
    switch(page){
        case 'inicio':
        case 'cuestionarios':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'planes':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'info':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'app':
            cta.innerHTML = `
				<!-- \u{1F510} AUTH BAR (renderizada por AuthHeaderController + AuthHeaderView) -->
				<div class="auth-bar" data-auth-header></div>
			`;
            break;
        default:
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html">[...to be configured]</a>
			`;
    }
}

});

// src/assets/js/pages/home/main.js

var $lA1wN = parcelRequire("lA1wN");
// src/assets/js/home/heroCarousel.js
function $001e8838d610dba1$export$73f663cb35f44b57({ root: root, intervalMs: intervalMs = 6000 } = {}) {
    if (!root) return;
    const viewport = root.querySelector('[data-carousel="viewport"]');
    const prevBtn = root.querySelector('[data-carousel="prev"]');
    const nextBtn = root.querySelector('[data-carousel="next"]');
    const dotBtns = Array.from(root.querySelectorAll('[data-carousel="dot"]'));
    const slides = Array.from(viewport?.querySelectorAll('.hero-slide') || []);
    // 👉 NUEVO: copys dinámicos del overlay
    const copies = Array.from(root.querySelectorAll('.hero-copy'));
    if (!viewport || slides.length === 0) return;
    let index = Math.max(0, slides.findIndex((s)=>s.classList.contains('is-active')));
    if (index < 0) index = 0;
    const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
    const setActive = (newIndex)=>{
        const i = (newIndex % slides.length + slides.length) % slides.length;
        const slideId = String(i + 1);
        // Slides (figuras)
        slides.forEach((s, n)=>{
            const isActive = n === i;
            s.classList.toggle('is-active', isActive);
            s.setAttribute('aria-hidden', String(!isActive));
        });
        // Dots
        dotBtns.forEach((d)=>d.classList.toggle('is-active', d.dataset.to === slideId));
        // 👉 NUEVO: Copy dinámico (H2 + P)
        copies.forEach((c)=>c.classList.toggle('is-active', c.dataset.slide === slideId));
        index = i;
    };
    const goNext = ()=>setActive(index + 1);
    const goPrev = ()=>setActive(index - 1);
    prevBtn?.addEventListener('click', goPrev);
    nextBtn?.addEventListener('click', goNext);
    dotBtns.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const to = Number(btn.dataset.to);
            if (Number.isFinite(to)) setActive(to - 1);
        });
    });
    // Autoplay
    let timer = null;
    const start = ()=>{
        if (prefersReduced) return;
        stop();
        timer = window.setInterval(goNext, intervalMs);
    };
    const stop = ()=>{
        if (timer) window.clearInterval(timer);
        timer = null;
    };
    // Pausa al hover/focus
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    setActive(index);
    start();
}


// src/assets/js/home/homeFavorites.js
// Favoritos (Landing SEO)
// - Lee/escribe en localStorage una lista de quizzes favoritos
// - Esquema: { quizId: HASH, subjectId, subjectTitle, quizTitle }
// - Key: quizId (único en la app)
// - Límite UI: 9 favoritos (si se supera, hace "shake" al botón)
const $10a950cd2fb669be$var$MAX_FAVS = 9;
const $10a950cd2fb669be$var$SHAKE_CLASS = 'is-shaking';
const $10a950cd2fb669be$var$SHAKE_MS = 420;
function $10a950cd2fb669be$var$safeParse(json, fallback) {
    try {
        return JSON.parse(json);
    } catch  {
        return fallback;
    }
}
function $10a950cd2fb669be$var$normalizeFav(item) {
    return {
        quizId: String(item?.quizId || '').trim(),
        subjectId: String(item?.subjectId || '').trim(),
        subjectTitle: String(item?.subjectTitle || '').trim(),
        quizTitle: String(item?.quizTitle || '').trim()
    };
}
function $10a950cd2fb669be$var$loadFavs(storageKey) {
    const raw = localStorage.getItem(storageKey);
    const data = $10a950cd2fb669be$var$safeParse(raw, {
        quizzes: []
    });
    const quizzes = Array.isArray(data?.quizzes) ? data.quizzes : [];
    // Normalizamos estructura: [{quizId, subjectId, subjectTitle, quizTitle}]
    return quizzes.map($10a950cd2fb669be$var$normalizeFav)// quizId es obligatorio (es la key)
    .filter((q)=>q.quizId);
}
function $10a950cd2fb669be$var$saveFavs(storageKey, favs) {
    localStorage.setItem(storageKey, JSON.stringify({
        quizzes: favs
    }));
}
function $10a950cd2fb669be$var$keyOf({ quizId: quizId }) {
    return quizId;
}
function $10a950cd2fb669be$var$setStarIcon(btn, isFav) {
    const icon = btn.querySelector('i');
    if (!icon) return;
    // FontAwesome: regular = vacío, solid = lleno
    icon.classList.toggle('fa-regular', !isFav);
    icon.classList.toggle('fa-solid', isFav);
    btn.setAttribute('aria-pressed', String(isFav));
}
function $10a950cd2fb669be$var$shake(el) {
    if (!el) return;
    // Reinicia animación si se dispara seguido
    el.classList.remove($10a950cd2fb669be$var$SHAKE_CLASS);
    // Forzar reflow
    // eslint-disable-next-line no-unused-expressions
    el.offsetWidth;
    el.classList.add($10a950cd2fb669be$var$SHAKE_CLASS);
    window.setTimeout(()=>{
        el.classList.remove($10a950cd2fb669be$var$SHAKE_CLASS);
    }, $10a950cd2fb669be$var$SHAKE_MS);
}
function $10a950cd2fb669be$export$a39e915faad72834({ root: root = document, storageKey: storageKey } = {}) {
    if (!storageKey) return;
    const favButtons = Array.from(root.querySelectorAll('[data-action="fav-quiz"]'));
    if (favButtons.length === 0) return;
    let favs = $10a950cd2fb669be$var$loadFavs(storageKey);
    const favSet = new Set(favs.map($10a950cd2fb669be$var$keyOf));
    // Pintado inicial
    favButtons.forEach((btn)=>{
        const quizId = String(btn.dataset.quizId || '').trim();
        if (!quizId) {
            btn.disabled = true;
            $10a950cd2fb669be$var$setStarIcon(btn, false);
            return;
        }
        $10a950cd2fb669be$var$setStarIcon(btn, favSet.has(quizId));
    });
    // Toggle
    favButtons.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const quizId = String(btn.dataset.quizId || '').trim();
            if (!quizId) return;
            const subjectId = String(btn.dataset.subjectId || '').trim();
            const subjectTitle = String(btn.dataset.subjectTitle || '').trim();
            const quizTitle = String(btn.dataset.quizTitle || '').trim();
            const isFav = favSet.has(quizId);
            // Quitar favorito
            if (isFav) {
                favSet.delete(quizId);
                favs = favs.filter((f)=>f.quizId !== quizId);
                $10a950cd2fb669be$var$saveFavs(storageKey, favs);
                $10a950cd2fb669be$var$setStarIcon(btn, false);
                return;
            }
            // Añadir favorito (con límite UI)
            if (favSet.size >= $10a950cd2fb669be$var$MAX_FAVS) {
                $10a950cd2fb669be$var$shake(btn);
                return;
            }
            favSet.add(quizId);
            // Guardamos también subjectId + títulos (para import y "Mis Materias")
            const favItem = {
                quizId: quizId,
                subjectId: subjectId,
                subjectTitle: subjectTitle,
                quizTitle: quizTitle
            };
            favs = [
                ...favs.filter((f)=>f.quizId !== quizId),
                favItem
            ];
            $10a950cd2fb669be$var$saveFavs(storageKey, favs);
            $10a950cd2fb669be$var$setStarIcon(btn, true);
        });
    });
}


document.addEventListener('DOMContentLoaded', ()=>{
    (0, $lA1wN.initHeaderActiveNav)();
    (0, $lA1wN.initHeaderCTA)();
    (0, $001e8838d610dba1$export$73f663cb35f44b57)({
        root: document.querySelector('.hero-carousel'),
        intervalMs: 6000
    });
    (0, $10a950cd2fb669be$export$a39e915faad72834)({
        root: document,
        storageKey: 'selectivia:favs'
    });
});
document.addEventListener('click', (e)=>{
    const btn = e.target.closest('[data-action="open-subject"]');
    if (!btn) return;
    const card = btn.closest('[data-subject-id], .subject-card');
    const subjectId = String(btn.dataset.subjectId || card?.dataset.subject || '').trim();
    if (!subjectId) return;
    e.preventDefault();
    e.stopPropagation();
    // redirige a la página de cuestionarios filtrada
    const href = `./quizzes.html?subject=${encodeURIComponent(subjectId)}`;
    window.location.href = href;
});


//# sourceMappingURL=SelectivIA.53a827a2.js.map
